import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import toastr from '../toastr'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import datePicker from '../../component/dccore-form/datePicker.vue'
import moment from 'moment'
import Checkbox from '../../component/simple-form/checkbox.vue'
import Singleselect from '../../component/singleselect.vue'
import SimpleSingleselect from '../../component/simple-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'

if ($('#old_purchase_order_materials_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#old_purchase_order_materials_form',
    delimiters: ['${', '}'],
    components: {
      RingLoader,
      Multiselect,
      moment,
      datePicker,
      Checkbox,
      Singleselect,
      TextInput,
      SimpleSingleselect
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        data: {
          dateFrom: moment().format('YYYY-MM-DD'),
          dateTo: moment().format('YYYY-MM-DD'),
          brands: [],
          categories: [],
          teams: [],
          allBrands: true,
          allTeams: true,
          mode: 'production',
          onlyProduction: true,
          forecast: false,
          warehouse: null,
        },
        options: {
          brands: [],
          categories: [],
          teams: [],
          supplyWarehouses: [],
          errors: {},
        },
      },
      materials:[],
      globalPlannedDate: moment().format('YYYY-MM-DD'),
      itemCount: 0,
      items: [],
      materialItems: [],
      deletedItems : [],
      modes : [
        'production',
        'min_state',
        'max_state'
      ]
    },
    mounted: function () {
      this.loading++
      this.getBrands()
      this.getCategories()
      this.getTeams()
      this.getOrderableMaterials()
      this.getSupplyWarehouses()

      this.loading--
    },
    methods: {
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getCategories() {
        let url = Routing.generate('api_get_tags', { type: 'portion_category',
          context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.categories = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getTeams() {
        let url = Routing.generate('api_get_active_production_teams', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.teams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getOrderableMaterials() {
        let url = Routing.generate('api_get_materials_orderable', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.materials = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getSupplyWarehouses: function () {
        this.loading++
        let url = Routing.generate('api_get_warehouse_supply_warehouses')

        Vue.http.get(url).then(response => {
          this.form.options.supplyWarehouses = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getOffersForMaterials(data) {
        let index = data.index
        let materialId = data.$event.id
        let url = Routing.generate('api_get_purchase_order_material_offers', { id: materialId })
        this.loading++
        this.$http.get(url).then(response => {

          this.$set(this.materialItems[index], 'offers', response.data)
          if (Object.keys(response.data).length > 0) {
            this.materialItems[index].selectedOffer = Object.values(response.data)[0].offerId
            this.materialItems[index].offer = this.materialItems[index].selectedOffer
          }

          this.getItemsForMaterial(materialId).forEach(item => {
            item.offers = response.data
            item.selectedOffer = item.offers.length > 0 ? Object.values(response.data)[0].offerId : null
            item.offer = item.selectedOffer
          })

          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
        this.$forceUpdate()
      },
      getItemsForMaterial(materialId) {
        return this.items.filter(item => item.materialId === materialId)
      },
      search(forecast) {
        this.itemCount = 0
        this.items = []
        this.refresh()
        let url = Routing.generate('api_search_purchase_order_material')
        this.form.data.forecast = forecast

        this.loading++
        this.$http.post(url, this.form.data).then(response => {
          this.items = response.data
          this.itemCount = Object.keys(this.items).length
          this.deletedItems = []
          this.prepareMaterialItems(response.data)

          toastr.success(Translator.trans('purchase_order.material.generate_completed'))

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      prepareMaterialItems(data) {
        let materialItems = []

        data.forEach(item => {
          let material = materialItems.filter(materialItem => materialItem.materialId === item.materialId)
          if (material.length > 0) {
            materialItems[materialItems.indexOf(material[0])].toOrder += item.toOrder
            materialItems[materialItems.indexOf(material[0])].quantity += item.quantity
          } else {
            let materialItem = Object.assign({}, item)

            if (materialItem.offer === null && Object.keys(item.offers).length > 0) {
              let offers = Object.values(materialItem.offers)
              offers.sort((a, b) => a.kgPrice - b.kgPrice)
            }

            materialItems.push(materialItem)
          }
        })

        this.materialItems = materialItems
      },
      addNew() {
        this.itemCount ++
        let data = {
          'categoryId' : null,
          'offer' : null,
          'offers' : [],
          'plannedDate' : null,
          'materialId' : null,
          'quantity' : 0,
          'toOrder'   : 0,
          'unit'  : null,
          'type'  :   'new',
          'supplyWarehouseId': null
        }
        this.items.push(data)
        this.materialItems.push(data)
      },
      generatePurchaseOrders(forecast = false) {
        $('.btn').button('loading')
        this.loading++

        let url = Routing.generate('api_generate_purchase_order_material')
        this.$http.post(url, {
          'items': this.getItems(),
          forecast
        }).then(() => {
          if (forecast) {
            toastr.success(Translator.trans('purchase_order.material.messages.forecasts_generated'))
          } else {
            toastr.success(Translator.trans('purchase_order.material.messages.orders_generated'))
          }
          this.items = []
          this.itemCount = 0
          this.loading--
          $('.btn').button('reset')
        }, response => {
          this.handleAjaxError(response, false, Translator.trans('purchase_order.material.messages.generate_error'))
          this.loading--
          $('.btn').button('reset')
        })
      },
      getSelectedfOfferData(index, name) {
        let offerId = this.materialItems[index].offer

        if (!offerId) {
          return null
        }

        let value = this.materialItems[index].offers[offerId][name]

        return value
      },
      changeOffer(data) {
        let index = data.index
        let weight = data.$event.weight
        let toOrderMaterial = 0

        this.getItemsForMaterial(this.materialItems[index].materialId).forEach(item => {
          item.toOrder = Math.ceil( item.quantity / weight )
          toOrderMaterial += item.toOrder
          item.offer = data.$event.offerId
        })

        this.materialItems[index].toOrder = toOrderMaterial
        this.materialItems[index].offer = data.$event.offerId

        this.refresh()
      },
      deleteRow(materialId) {
        if (confirm(Translator.trans('form.confirm'))) {
          this.deletedItems.push(materialId)
        }
      },
      getItems() {
        let deletedItems = this.deletedItems

        this.items.forEach(item => {
          if (!item.offer) {
            let materialItems = this.materialItems.filter(mItem => mItem.materialId === item.materialId)
            if (!!materialItems[0] && !!materialItems[0].offer) {
              item.offer = materialItems[0].offer
            }
          }
        })

        return Object.values(this.items).filter(item => deletedItems.indexOf(item.materialId) < 0 && !!item.offer)
      },
      setPlannedDates() {
        Object.values(this.items).forEach(item => {
          item.plannedDate = this.globalPlannedDate
        })
        Object.values(this.materialItems).forEach(item => {
          item.plannedDate = this.globalPlannedDate
        })
      },
      translateMode(name) {
        return Translator.trans(`purchase_order.material.modes.${name}`)
      }
    },
  })
}
